import { gql } from "@apollo/client";

const UPDATE_GRANT_PAYMENT_STATUS = gql`
mutation UpdateGrantPaymentStatus($transactionId: ID) {
  updateGrantPaymentStatus(transactionId: $transactionId)
}`;

const CREATE_GRANT_PAYMENT = gql`
mutation SendGrantPayment($transactionId: ID) {
  sendGrantPayment(transactionId: $transactionId)
}`;

export { UPDATE_GRANT_PAYMENT_STATUS, CREATE_GRANT_PAYMENT };